

import Frame1 from '../../assets/imgs/blog/Frame1321315402.png';
import Frame2 from '../../assets/imgs/blog/Frame1321315403.png';
import Frame3 from '../../assets/imgs/blog/Frame1321315404.png';

import Frame1_1 from '../../assets/imgs/blog/Frame1321315402_2.png';
import Frame2_2 from '../../assets/imgs/blog/Frame1321315403_3.png';
import Frame3_3 from '../../assets/imgs/blog/Frame1321315404_4.png';

export const BLOG_DATA = [
    {
        blogImg: Frame1,
        coverImg: Frame1_1,
        title: "Germany Study Visa Requirements for Indian Students: Complete Updated Checklist 2025",
        subtitle: [
            "Shashwat German School – Best German Language Institute & Visa Support for Germany",
            "Applying for a Germany study visa as an Indian student requires precise documentation and adherence to embassy regulations. The process involves more than just admission — it includes language certifications, APS validation, financial proof, and medical insurance, among other essentials.",
            "At Shashwat German School, we don’t just teach the German language (A1 to B1 levels) — we help students through the entire study visa process, from documentation to mock interviews.",
            "This guide outlines the latest Germany student visa requirements (2025) for Indian applicants, based on current embassy and VFS Global rules.",
        ],
        checklist: [
            {
                title: "1. Valid Passport",
                description: "Your passport must be:",
                requirements: [
                    "Valid for at least 12 months beyond your intended stay.",
                    "Must contain minimum two blank pages.",
                    "Issued within the last 10 years."
                ]
            },
            {
                title: "2. Letter of Admission from a German University",
                description: "This is your Zulassungsbescheid, i.e., official admission letter. It should come from a recognized German university or institution, and clearly state your:",
                requirements: [
                    "Course name and duration",
                    "Mode of instruction (German/English)",
                    "Semester start date",
                    "Conditional admissions are accepted but require proof of eligibility fulfillment."
                ]
            },
            {
                title: "3. Academic Documents",
                description: "You must submit all previous academic records:",
                requirements: [
                    "10th & 12th certificates and mark sheets",
                    "Bachelor’s degree and mark sheets (if applying for PG)",
                    "Medium of Instruction certificate, if applicable",
                    "Transcripts (semester-wise and consolidated)",
                    "All documents must be properly attested, and translated into German/English if not originally issued in those languages."
                ]
            },
            {
                title: "4. German or English Language Proficiency Certificate",
                description: "Language proficiency is mandatory based on your course medium: For German-taught programs:",
                requirements: [
                    {
                        "type": "German-taught programs",
                        details: [
                            "A1 to B1 level German language certificate",
                            "Valid from institutions like Goethe-Institute, telc, ÖSD, or Shashwat German School"
                        ]
                    },
                    {
                        "type": "English-taught programs",
                        details: [
                            "IELTS (minimum 6.0 overall) or TOEFL equivalent"
                        ]
                    }
                ],
                note: "At Shashwat German School, students receive certified training, regular assessments, and mock exams for both language types."
            },
            {
                title: "5. Proof of Financial Resources – Blocked Account",
                description: "To show financial capacity, students must open a Blocked Account (Sperrkonto) in Germany with a minimum deposit of:",
                requirements: [
                    "Blocked Account (Sperrkonto) in Germany with a minimum deposit of €11,208 per year (approx. ₹10,00,000 INR as of 2025)"
                ],
                "providers": ["Fintiba", "Expatrio", "Coracle"],
                note: "Confirmation letter from the provider is required. Shashwat German School provides full support in blocked account setup, document upload, and troubleshooting."
            },
            {
                title: "6. Health Insurance",
                description: "Health insurance is mandatory to get a study visa. You’ll need:",
                requirements: [
                    "Travel Insurance (valid for the initial 3 months)",
                    "Switch to public or private health insurance (e.g., TK, AOK, Barmer) once in Germany",
                    "Approved Indian providers with German tie-ups are acceptable"
                ]
            },
            {
                title: "7. APS Certificate (Academic Evaluation Centre)",
                description: "Since November 2022, APS certification is compulsory.",
                "documents": [
                    "All mark sheets and degree certificates",
                    "German/English translations if required",
                    "Passport and ID",
                    "Proof of application to a German university",
                    "Language certificate (A1-B1, IELTS, etc.)"
                ],
                note: "APS takes 3 to 6 weeks. Shashwat assists with application, translation, courier submission, and follow-up."
            },
            {
                title: "8. Visa Application Form and Declarations",
                description:"You must submit a National D-Visa application form, along with required declarations:",
                requirements: [
                    "Filled and signed national visa form",
                    "Cover letter (explaining your study plan and financial means)",
                    "Declaration form as per embassy requirement"
                ]
            },
            {
                title: "9. SOP (Statement of Purpose)",
                description:"The SOP is a key part of your application and should include:",
                requirements: [
                    "Why you want to study in Germany",
                    "Reasons for choosing the university/course",
                    "Career goals and financial preparation",
                    "Commitment to return to India or your career plan"
                ],
                note: "Shashwat helps draft a professional SOP meeting embassy standards."
            },
            {
                title: "10. Passport-Size Photographs",
                description:"Submit two biometric photographs:",
                requirements: [
                    "Size: 35mm x 45mm",
                    "White background",
                    "No headgear, clear face",
                    "Follow German photo rules strictly"
                ]
            },
            {
                title: "11. Proof of Accommodation (If Available)",
                description:"Some embassies may ask for proof of your stay in Germany. This can be:",
                requirements: [
                    "Student residence booking",
                    "Hostel/hotel booking",
                    "Invitation letter from a friend/relative"
                ]
            },
            {
                title: "12. Visa Fee",
                description:"The current German student visa application fee is:",
                requirements: [
                    "€75 (approx. ₹6,500 INR)",
                    "Payable via bank draft or cash (as per embassy/VFS rules)"
                ]
            }
        ],
        additionalNotes: [{
            queries: "Additional Notes: Embassy Appointment and Processing",
            notes: [
                "Book your VFS appointment early (slots are limited)",
                "Carry two complete document sets (original + photocopies)",
                "Embassy may request additional documents or a personal interview"
            ]
        }],
        support: [{
            queries: "How Shashwat German School Helps You",
            description: "At Shashwat German School, we provide a complete ecosystem to help you study in Germany, including:",
            services: [
                "German Language Courses (A1 to B1) with certified instructors",
                "APS Certificate guidance and translations",
                "Complete visa file preparation with documentation checks",
                "Blocked account and health insurance setup",
                "SOP drafting and review",
                "Mock visa interviews and embassy updates"
            ],
            note: "Whether you're a beginner in German or already preparing for your visa, we offer affordable, flexible, and result-driven solutions tailored for Indian students."
        }]
    },
    {
        blogImg: Frame2,
        coverImg: Frame2_2,
        title: "Germany Study Visa Rejection Reasons for Indian Students & How Shashwat German School Helps Avoid Them",
        subtitle: [
            "Many Indian students face rejection due to avoidable mistakes. Shashwat German School offers comprehensive support to help avoid these issues.",
            "Breakdown of real rejection reasons and how expert support from Shashwat German School helps overcome them."
        ],
        checklist: [
            {
                title: "1. Incomplete or Incorrect Documents",
                details: "Visa rejection due to poorly arranged or incomplete visa file.",
                requirements: [
                    "Provides embassy-based checklists",
                    "Reviews every document before submission",
                    "Helps organize professional visa files"
                ]
            },
            {
                title: "2. Low German Language Proficiency",
                details: "Rejection due to not meeting required German language level or invalid certificates.",
                requirements: [
                    "Certified German courses (A1 to B2) by expert trainers",
                    "Preparation for Goethe and \u00d6SD exams",
                    "Mock exams for practice"
                ]
            },
            {
                title: "3. Incorrect Financial Proofs or Blocked Account Issues",
                details: "Rejection occurs if blocked account is invalid, insufficient, or not verified.",
                requirements: [
                    "Guidance for opening accounts with providers like Fintiba/Expatrio",
                    "Explains all funding options like sponsorship and loan letters",
                    "Verifies documents to ensure correctness"
                ]
            },
            {
                title: "4. Weak or Copy-Pasted SOP",
                details: "Generic or insincere SOPs lead to rejections as they lack personal insight.",
                requirements: [
                    "One-on-one SOP sessions with mentors",
                    "Custom SOPs based on student background and goals",
                    "Help in writing genuine and clear SOPs"
                ]
            },
            {
                title: "5. Poor Performance in Visa Interviews",
                details: "Low confidence or unclear answers during interview result in visa denials.",
                requirements: [
                    "Mock visa interviews with expert feedback",
                    "Training on commonly asked questions",
                    "Fluency, confidence, and clarity coaching"
                ]
            }
        ],
        additionalNotes: [{
            queries: "Why Students Trust Shashwat German School?",
            summary: "At Shashwat German School, we understand what the German Embassy expects. Our visa guidance program is realistic, practical, and updated regularly based on real student experiences and embassy feedback. We’ve successfully guided students to top universities and colleges across Germany.Our support doesn’t stop at teaching the German language – we walk with you through the entire process: from learning German to securing your visa.",
        }],
        support: [{
            queries: "Final Thoughts",
            description: "Visa rejections are stressful—but most of the time, they are avoidable. With proper planning, strong preparation, and expert support, you can greatly increase your chances of visa approval. If you’re serious about studying in Germany, don’t take chances with your visa file. Reach out to Shashwat German School and let us help you do it the right way from the beginning."
        }]
    },
    {
        blogImg: Frame3,
        coverImg: Frame3_3,
        title: "From A1 to Visa Interview: How Shashwat German School Helps Indian Students Study in Germany",
        subtitle: [
            "Studying in Germany is a dream for thousands of Indian students. But between learning German, preparing documents, securing admission, and facing the visa interview, the process can feel overwhelming. Many students either get stuck or end up with incomplete applications due to poor guidance.",
            "At Shashwat German School, we simplify the entire process\u2014from your first German language class to your final visa interview. Here's a step-by-step look at how we help you at every stage of your journey to study in Germany.",
        ],
        checklist: [
            {
                title: "1. Learning German \u2013 From A1 to B2",
                description: "German universities and visa authorities require students to demonstrate language proficiency. Depending on your course (especially in public universities), you may need a Goethe or ÖSD certificate for levels A1, A2, B1, or B2.",
                requirements: [
                    "German universities and visa authorities require students to demonstrate language proficiency.",
                    "Structured classes for A1 to B2, taught by experienced faculty.",
                    "Regular mock tests and internal assessments.",
                    "Preparation for Goethe and \u00d6SD exams with practice materials and test strategies.",
                    "Flexible batch timings for students and working professionals.",
                    "Fact: For most bachelor's and language preparatory programs, B1 or B2 is usually required."
                ]
            },
            {
                title: "2. University Admission Assistance",
                description: "Finding the right course and university in Germany can be tricky. Many students waste months applying to the wrong programs or missing deadlines.",
                requirements: [
                    "Shortlisting of public and private universities based on your profile.",
                    "Guidance on application portals (Uni-Assist, direct applications).",
                    "Help with document preparation: transcripts, LORs, CV, SOP.",
                    "Deadline tracking and email communication assistance.",
                    "Fact: Indian students applying for Studienkolleg or language pathway programs often start with A1 or A2-level German, then upgrade to B1/B2 while in Germany."
                ]
            },
            {
                title: "3. Visa File Preparation \u2013 The Correct Way",
                description: "A large number of Indian students face visa rejections due to errors in their visa file. From blocked account details to insurance documents, every paper must be accurate and arranged as per embassy standards.",
                requirements: [
                    "Preparing a complete visa file with a verified document checklist.",
                    "Opening blocked accounts through approved providers like Fintiba or Expatrio.",
                    "Getting valid health insurance, travel insurance, and financial documents.",
                    "Writing a personalized SOP (Statement of Purpose) to reflect genuine intent.",
                    "Fact: As per the German embassy in India, blocked account minimum funds for 2025 are approx. \u20ac11,208 (INR 10 lakhs)."
                ]
            },
            {
                title: "4. Visa Interview Preparation",
                description: "Many students get nervous or are unprepared during their German visa interview. Poor answers, lack of clarity about course details, or hesitation can raise red flags with visa officers.",
                requirements: [
                    "Conduct mock visa interviews based on real embassy questions.",
                    "Work on your confidence, clarity, and fluency.",
                    "Train you to answer questions related to:",
                    "Your course and university, your future plans, financial preparedness, why Germany?, your language skills.",
                    "Fact: In 2024, many Indian students were asked detailed questions about funding sources and course contents during their visa interviews."
                ]
            },
            {
                title: "5. Continued Support After Visa Approval",
                description: "Unlike other centers, our service doesn’t end with your visa approval.",
                requirements: [
                    "Pre-departure briefing (travel, accommodation, culture tips).",
                    "Help with booking flight and airport pickups (if available).",
                    "Guidance on registering in Germany (Anmeldung), residence permits, and university orientation."
                ]
            }
        ],
        additionalNotes: [{
            queries: "Why Choose Shashwat German School?",
            summary: "At Shashwat German School, we don’t just teach German—we help you move to Germany with full preparation. Every step of your journey is covered under one roof. Our students come from different parts of India and successfully secure their student visas with confidence.",
            services: "Our Core Services:",
            notes: [
                "A1 to B2 German Language Classes",
                "Goethe & \u00d6SD Exam Prep",
                "Visa File Preparation",
                "SOP Writing & Editing",
                "Blocked Account & Insurance Assistance",
                "University Admission Guidance",
                "Mock Visa Interview Training",
                "Pre-departure & Post-Arrival Help"
            ]
        }],
        support: [{
            queries: "Final Words",
            services: [
                "If you're serious about studying in Germany, don\u2019t rely on scattered information or random advice. The process is achievable\u2014with the right guidance. At Shashwat German School, we treat your journey like our own. From your first day in the classroom to the day you board your flight, we are with you.",
                "Join the hundreds of Indian students who are now studying in Germany\u2014without stress, without confusion."
            ]
        }]
    }

]







// export const BLOG_DATA = [
//     {
//         mainHeading: "Germany Study Visa Requirements for Indian Students: Complete Updated Checklist 2025.",
//         blogImg: Frame1,
//         coverImg: Frame1_1,
//         subHeadingMain: [
//             {
//                 list: "Shashwat German School – Best German Language Institute & Visa Support for Germany.",

//             },
//             {
//                 list: "Applying for a Germany study visa as an Indian student requires precise documentation and adherence to embassy regulations. The process involves more than just admission — it includes language certifications, APS validation, financial proof, and medical insurance, among other essentials.",

//             },
//             {
//                 list: "At Shashwat German School, we don’t just teach the German language (A1 to B1 levels) — we help students through the entire study visa process, from documentation to mock interviews.",

//             },
//             {
//                 list: "This guide outlines the latest Germany student visa requirements (2025) for Indian applicants, based on current embassy and VFS Global rules.",

//             }

//         ],

//     },
//     {
//         mainHeading: "Germany Study Visa Rejection Reasons for Indian Students & How Shashwat German School Helps Avoid Them.",
//         blogImg: Frame2,
//         coverImg: Frame2_2,
//         subHeadingMain: [
//             {
//                 list: "If you’re planning to study in Germany, getting your student visa approved is one of the most important steps. Unfortunately, many Indian students face rejection due to avoidable mistakes. At Shashwat German School, we’ve helped hundreds of students successfully prepare for their Germany student visa, and we know exactly where things often go wrong.",

//             },
//             {
//                 list: "In this article, we’ll break down the real reasons Germany study visas get rejected and explain how our expert team helps students avoid these problems through accurate guidance, complete documentation, language preparation, and personalized support.",

//             },

//         ],

//     },
//     {
//         mainHeading: "From A1 to Visa Interview: How Shashwat German School Helps Indian Students Study in Germany.",
//         blogImg: Frame3,
//         coverImg: Frame3_3,
//         subHeadingMain: [
//             {
//                 list: "Studying in Germany is a dream for thousands of Indian students. But between learning German, preparing documents, securing admission, and facing the visa interview, the process can feel overwhelming. Many students either get stuck or end up with incomplete applications due to poor guidance.",

//             },
//             {
//                 list: "At Shashwat German School, we simplify the entire process—from your first German language class to your final visa interview. Here's a step-by-step look at how we help you at every stage of your journey to study in Germany.",

//             },

//         ],

//     }
// ]
